import produce from 'immer'
import Actions from '../actions'

const initialState = {
  pastVisits: [],
  currentPastVisitsList: [],
  visitSummary: [],
  selectedPastVisit: null,
  selectedWorkNote: null,
  workNotes: [],
  currentWorkNotes: [],
  selectedReferral: null,
  referrals: [],
  currentReferrals: [],
  currentFile: null,
  prescriptions: [],
  currentPrescriptions: [],
  testResults: [],
  selectedTestResult: null,
  selectedPrescription: null,
  consents: [],
  currentConsents: [],
  selectedConsent: null,
  isLoadingDocs: false,
  questReferrals: [],
  currentQuestReferrals: [],
  genericReferrals: [],
  questReferralResults: null,
  referralFacility: {},
  isReferralsLoading: false,
  selectedPdf: '',
  questReferralRecieveLoader: false,
  questReferralResultsLoading: false,
  questReferralResultsError: false
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.PATIENT_DOCS_REQUESTED: {
      draft.isLoadingDocs = true
      break
    }
    case Actions.VISIT_SUMMARY_REQUESTED: {
      draft.isLoadingDocs = true
      break
    }
    case Actions.PATIENT_DOCS_RECIEVED: {
      draft.pastVisits = payload?.pastVisitsLists
      draft.workNotes = payload?.workNotesLists
      draft.referrals = payload?.referralsLists
      draft.testResults = payload?.testResultsLists
      draft.prescriptions = payload?.prescriptionsLists
      draft.consents = payload?.consentsLists
      draft.isLoadingDocs = false
      break
    }
    case Actions.PATIENT_DOCS_FAILED: {
      draft.isLoadingDocs = false
      break
    }
    case Actions.VISIT_SUMMARY_FAILED: {
      draft.isLoadingDocs = false
      break
    }
    case Actions.VISIT_SUMMARY_RECEIVED: {
      if (payload?.visitSummary) {
        draft.visitSummary = payload?.visitSummary
      }
      draft.isLoadingDocs = false
      break
    }
    // updating medical lists according to family selectBox
    case Actions.CHOOSE_FAMILY_MEMBER: {
      const { member } = payload
      // member id is string the patient id is int
      // in order to protect for such cases, we need to convert both to same type
      // and then compare
      const memberId = member?.id?.toString()
      draft.currentPastVisitsList = draft.pastVisits?.filter(
        record => !memberId || record?.patient?.toString() === memberId
      )
      draft.currentWorkNotes = draft.workNotes?.filter(
        record => !memberId || record?.patient?.toString() === memberId
      )
      draft.currentReferrals = draft.referrals?.filter(
        record => !memberId || record?.patient?.toString() === memberId
      )
      draft.currentPrescriptions = draft.prescriptions?.filter(
        record => !memberId || record?.patient?.toString() === memberId
      )
      draft.currentConsents = draft.consents?.filter(
        record => !memberId || record?.patient?.toString() === memberId
      )
      break
    }
    case Actions.SET_PAST_VISITS_LIST: {
      draft.currentPastVisitsList = draft.pastVisits?.filter(
        record =>
          !payload?.id ||
          record?.patient?.toString() === payload?.id?.toString()
      )
      break
    }
    case Actions.SHOW_PAST_VISIT: {
      const { item } = payload
      draft.selectedPastVisit = item
      break
    }
    case Actions.SET_WORK_NOTES_BY_ID: {
      draft.currentWorkNotes = draft.workNotes?.filter(
        record =>
          !payload?.id || record?.patient.toString() === payload?.id?.toString()
      )
      break
    }
    case Actions.SHOW_WORK_NOTE: {
      const { item } = payload
      draft.selectedWorkNote = item
      break
    }
    case Actions.SET_REFERRALS_BY_ID: {
      draft.currentReferrals = draft.referrals?.filter(
        record =>
          !payload?.id ||
          record?.patient?.toString() === payload?.id?.toString()
      )
      draft.currentQuestReferrals = draft.questReferrals?.filter(
        record =>
          !payload?.id ||
          record?.patient?.toString() === payload?.id?.toString()
      )
      break
    }
    case Actions.SET_PRESCRIPTIONS_BY_ID: {
      draft.currentPrescriptions = draft.prescriptions?.filter(
        record =>
          !payload?.id ||
          record?.patient?.toString() === payload?.id?.toString()
      )
      break
    }
    case Actions.SHOW_PRESCRIPTIONS: {
      const { item } = payload
      draft.selectedPrescription = item
      break
    }
    case Actions.SET_CONSENTS_BY_ID: {
      draft.currentConsents = draft.consents?.filter(
        record =>
          !payload?.id ||
          record?.patient?.toString() === payload?.id?.toString()
      )
      break
    }
    case Actions.SHOW_CONSENTS: {
      const { item } = payload
      draft.selectedConsent = item
      break
    }
    case Actions.PATIENT_FILE_RECEIVED: {
      draft.currentFile = payload.file
      break
    }
    case Actions.PAST_VISIT_RECEIVED: {
      draft.selectedPastVisit = payload.item
      break
    }
    case Actions.SHOW_REFERRAL: {
      const { item } = payload
      draft.selectedReferral = item
      break
    }
    case Actions.QUEST_REFERRALS_RECEIVED: {
      draft.questReferralRecieveLoader = false
      const { result } = payload
      const questReferrals = Array.isArray(result)
        ? result?.map(referral => {
            return { ...referral, isQuestReferral: true }
          })
        : []
      draft.questReferrals = questReferrals
      break
    }

    case Actions.GENERIC_REFERRALS_REQUESTED: {
      draft.isReferralsLoading = true
      break
    }
    case Actions.GENERIC_REFERRALS_RECEIVE_FAILED: {
      draft.isReferralsLoading = false
      break
    }

    case Actions.QUEST_REFERRALS_RESULTS_REQUESTED: {
      draft.questReferralResultsLoading = true
      draft.questReferralResultsError = false
      break
    }

    case Actions.QUEST_REFERRALS_RESULTS_RECEIVED: {
      if (Array.isArray(payload)) {
        draft.questReferralResults = payload
        draft.questReferralResultsError = false
      } else {
        draft.questReferralResults = null
        draft.questReferralResultsError = true
      }
      draft.questReferralResultsLoading = false
      break
    }
    case Actions.SELECTED_LAB_FACILITY_LOCATION_RECEIVED: {
      draft.referralFacility = payload?.msg
      break
    }
    case Actions.SELECTED_LAB_FACILITY_LOCATION_FAILED: {
      draft.referralFacilityError = true
      break
    }
    case Actions.CLEAR_SELECTED_LAB_FACILITY_LOCATION_: {
      draft.referralFacilityError = false
      draft.referralFacility = {}
      break
    }
    case Actions.VIEW_DOCUMENT_BY_URL: {
      draft.selectedPdf = payload?.pdf
      break
    }
    case Actions.CLEAR_VIEW_DOCUMENT_BY_URL: {
      draft.selectedPdf = ''
      break
    }
    case Actions.QUEST_REFERRALS_REQUESTED: {
      draft.questReferralRecieveLoader = true
      draft.isReferralsLoading = false
      break
    }
    case Actions.OPERATION_FAILED: {
      draft.questReferralRecieveLoader = false
      draft.isReferralsLoading = false
      draft.questReferralResultsLoading = false
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      return initialState
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
